import $ from "jquery";
const body = document.body;
const $header = document.querySelector(".header");
const scrollUpCssClass = "scroll-up";
const scrollDownCssClass = "scroll-down";
let isScrollDown = false;
let lastScroll = 0;
let open = false;
const $burger = document.querySelector(".js-burger");
const $closeBtn = document.querySelector(".navigation-area__close");
const mqIsDesktop = window.matchMedia("(min-width: 992px)");
let megaMenuIsOpen = false;
let activeMenuId = null;
const scrollUpDelta = 20;
const scrollDownDelta = 5;
const $categoryLinks = $(".js-category-link");
const $navArea = document.querySelector(".navigation-area");

var header = {
  init: function() {
    if (!$burger) return;
    $burger.addEventListener("click", onBurgerClick);
    window.addEventListener("scroll", onScrollChange, { passive: true });
    window.addEventListener("header-toggle", onHeaderToggle);
    
    $categoryLinks.on("click", (e) => {
      const id = e.currentTarget.dataset.id;
      
      if (id === activeMenuId) {
        changeCategory(null, null);
        e.preventDefault();
        return;
      }

      changeCategory(id, e.currentTarget);
      e.preventDefault();
    });

    // reset menu state on mq change
    mqIsDesktop.onchange = (e) => changeCategory(null, null);
  }
};

function onDocumentClicked(e) {  
  // check if click is outside of navigation area
  if (!$navArea.contains(e.target)){
    changeCategory(null, null);
    document.removeEventListener('click', onDocumentClicked);
  }
}

function onBurgerClick() {
  var event = new CustomEvent("header-toggle", { detail: { search: false, navigation: !open } });
  window.dispatchEvent(event);
}

function changeCategory(id, item) {  
  activeMenuId = id;
  var event = new CustomEvent("navigation-category", {
    detail: { categoryId: id }
  });
  window.dispatchEvent(event);
  document
    .querySelectorAll(".subnav__link--open")
    .forEach((item) => item.classList.remove("subnav__link--open"));

  if (id && item) {
    item.classList.add("subnav__link--open");
    megaMenuIsOpen = true;
    $closeBtn.addEventListener("click", (e) => changeCategory(null, null));
    document.addEventListener('click', onDocumentClicked);
    toggleOtherElements(true);
  } else {
    megaMenuIsOpen = false;
    $closeBtn.removeEventListener("click", (e) => changeCategory(null, null));
    document.removeEventListener('click', onDocumentClicked);
    toggleOtherElements(false);
  }
}

function onHeaderToggle(e) {
  open = e.detail.navigation;
  const openSearch = e.detail.search;
  const openNavigation = e.detail.navigation;
  $burger.setAttribute("aria-expanded", openNavigation);
  $burger.classList.toggle("collapsed", !openNavigation);
  toggleOtherElements(openNavigation || openSearch);
}

function setScrollDirection(direction) {
  switch (direction) {
    case "up":
      isScrollDown = false;
      body.classList.remove(scrollDownCssClass);
      body.classList.add(scrollUpCssClass);
      break;
    case "down":
      isScrollDown = true;
      body.classList.add(scrollDownCssClass);
      body.classList.remove(scrollUpCssClass);
      break;

    default:
      isScrollDown = false;
      body.classList.remove(scrollUpCssClass);
      body.classList.remove(scrollDownCssClass);
      break;
  }
}

const onScrollChange = () => {
  if (megaMenuIsOpen) {
    return;
  }

  const currentScroll = window.scrollY;

  if (currentScroll <= 100) {
    setScrollDirection(null);
    return;
  }

  if (currentScroll > lastScroll + scrollDownDelta && !isScrollDown) {
    setScrollDirection("down");
  } else if (currentScroll < lastScroll - scrollUpDelta && isScrollDown) {
    setScrollDirection("up");
  }
  lastScroll = currentScroll;
};

function toggleOtherElements(open) {
  body.classList.toggle("scroll--disabled", open);
  $header.classList.toggle("header--open", open);
  document.querySelector("main").inert = open;
  document.querySelector("footer").inert = open;
}

export default header;
